import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router';
import { FormInput } from '../../../components/FormInput';
import { Button } from 'primereact/button';
import { F2010202Before, getRoleList, reviewSubAccount, updateSubAccData } from "../../../utility/service/personal-service";
import { checkDpSuccess } from "../../../utility/service/tool-service";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { handleSuccessMessage,MessageContext } from "../../../store/messageStore";
import { AlertService } from "../../../utility/service/alert-service";
import PrimeConfirmDialog from "../../../components/dialog/PrimeConfirmDialog";
import { addFormValidator } from "../../../utility/validate/formValidator";
import { updateAuditEyesEvent } from "../../../utility/service/audilog-service";
import { useFuncId } from "../../../router/menuRouterMapper";
import { MaskedFormInput } from "../../../components/MaskedFormInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TreeSelect } from "primereact/treeselect";

const SubAccountDetail = () => {
    const { setAction, action ,setItemObj, itemObj } = useOutletContext();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [roleList, setRoleList] = useState([]);
    const [, dispatch] = useContext(MessageContext); //訊息視窗 
    const [statusList, setStatusList] = useState([]);
    const [delDialog, setDelDialog] = useState(false);
    const [delContent, setDelContent] = useState("");
    const [formRule, setFormRule] = useState([]); //表單驗證
    const [maskView,setMaskView] = useState(false);
    const [defaultRoleSeq, setDefaultRoleSeq] = useState('');
    const chsFuncId = useFuncId();
    
    const confirmDel = () => { //確認刪除
        deleteAcct()
    }

    const axios_getRoleList = ()=>{
        // 父節點下拉選項
        const formatToTreeSelect = (nodes) => {
          return nodes.map((node) => ({
            key: node.key,
            label: node.data.name,
            data: node.data,
            children: node.children ? formatToTreeSelect(node.children) : null,
          }));
        };
        getRoleList()
          .then((res)=>{
            if(checkDpSuccess(res)){
              let data = res.data.RespBody.roleList;
              setRoleList(formatToTreeSelect(data));
              let matchedRole = data?.filter((item)=>item.name===itemObj?.roleName);
              if(matchedRole?.length > 0){
                setValue("roleSeq",matchedRole[0].roleSeq)
                setDefaultRoleSeq(matchedRole[0].roleSeq)
              }
            
            }
          })
      }

    const handleUpdateSubAccData = (reqBody,subAccountOperation="0")=>{ //subAccountOperation 0編輯 /1 刪除
        reqBody.subAccountOperation = subAccountOperation
        updateSubAccData(reqBody)
        .then((res)=>{
            if(checkDpSuccess(res)){
                handleSuccessMessage(dispatch, t(`button.${subAccountOperation==='0'?'update':'delete'}`) + ' ' + t('message.success'));
                navigate('/management/subAccountSetting');
            }
        })
    }
    
    const deleteAcct = ()=>{
        let reqBody = {
            userSeq:itemObj?.userSeq,
            name:getValues("name"),
            phone:getValues("phone"),
            email:getValues("email"),
            roleSeq:getValues("roleSeq")===undefined||getValues("roleSeq")===''?'':getValues("roleSeq"),
            status:getValues("status")
        }
        handleUpdateSubAccData(reqBody,"1")
    }

    const onSubmit = (data) => {
        let reqBody = {
            userSeq:itemObj?.userSeq,
            name:data.name,
            phone:data.phone,
            email:data.email,
            roleSeq:data.roleSeq===undefined||data.roleSeq===''?'':data.roleSeq,
            status:data.status
        }
        handleUpdateSubAccData(reqBody,"0")
    }

    const handlePassOrReject = (status,roleSeq)=>{ //審核子帳戶(通過/退回)
        if(status==='2' && ( roleSeq==='' ||  roleSeq===undefined) ){ //審核 roleSeq必填
            AlertService.ok(t('role'),t('validation.required'));
            return
        }
        reviewSubAccount({
            userSeq:itemObj?.userSeq,
            subAccountOperation:status,
            roleSeq
        })
        .then((res)=>{
            if(checkDpSuccess(res)){
                handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                navigate('/management/subAccountSetting');
            }
        })
    }

    const [detail ,setDetail]=useState({});
    const [disabled, setDisabled] = useState(false);

    const { handleSubmit, setValue,getValues, register,control, formState: { errors, isValid, isDirty} } = useForm({
        defaultValues: {
            acct: '',
            name: '',
            phone: "",
            email: '',
            roleName: "",
            status:'',
            roleSeq:''
        },
        //錯誤驗證時機
        mode: "all"
    })
    useEffect(()=>{
        if(JSON.stringify(itemObj)==="{}"){
            navigate('/management/subAccountSetting');
          }else{
            for (const key in itemObj){
                setValue(key,itemObj[key])
            }
          }

    },[])

    // 

    //建立前查詢form 規則
    const axios_getCreateBefore = ()=>{
      F2010202Before()
        .then((res)=>{
            if(checkDpSuccess(res)){
                let array = []
                res?.data?.RespBody?.constraints?.forEach((item) => {
                    const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                    array.push(result)
                })
                setFormRule(array);
            }
        })
    }

    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);

    useEffect(()=>{
       switch (action) {
        case 'update':
            setDisabled(true); //先唯讀,按[編輯]才開放
            axios_getRoleList();
            setValue("status",itemObj?.statusCode);
            axios_getCreateBefore();//統一檢核
            if(getValues("status")!=='9'){
                setStatusList([
                    {
                      label: t('activated'),
                      value: "0",
                      selected: false,
                      groupKey: "",
                    },
                    {
                      label: t('suspended'),
                      value: "1",
                      selected: false,
                      groupKey: "",
                    }
                  ])
            }else{
                setStatusList([
                    {
                      label: t('suspended'),
                      value: "9",
                      selected: false,
                      groupKey: "",
                    },
                   
                  ])  
            }
            break;
            
        case 'detail':
            setDisabled(true);
            setValue("status",itemObj?.status);
            setValue("roleName",itemObj?.roleName);
            break;
       
        default:
            setDisabled(true);
            break;
       }
    },[])

    const axios_updateAuditEyesEvent = ()=>{
        updateAuditEyesEvent({
            functionId:chsFuncId,
            eventType:action==='update'?'E':'V'
        })
        .then((res)=>{
            if(checkDpSuccess(res)){

            }
        })
    }

    const handleStartEdit = () => {
        setDisabled(false);
        if (!maskView) { //進入編輯後name/email即為明碼,補記稽核
            axios_updateAuditEyesEvent();
        }
    }

    const handleCancelEdit = () => { //還原資料並回到唯讀
        for (const key in itemObj) {
            setValue(key, itemObj[key]);
        }
        setValue("status", itemObj?.statusCode);
        setValue("roleSeq", defaultRoleSeq);
        setDisabled(true);
        setMaskView(false);
    }

    return (
      <>
        {/* 返回列表 */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <Button
              rounded
              text
              onClick={() => {
                navigate("/management/subAccountSetting");
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
              {t("button.return_to_list")}
            </Button>
          </div>
          <div>
            <Button
              type="button"
              icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
              severity="secondary"
              onClick={() => {
                setMaskView((prev) => {
                  if (!prev) {
                    axios_updateAuditEyesEvent();
                  }
                  return !prev;
                });
              }}
            />
          </div>
        </div>
        <div className="p-card">
          <div className="p-card p-card-body">
            <form onSubmit={handleSubmit(onSubmit)} className="grid">
              <div className="col-12 lg:col-6">
                {/* <FormInput
                                register={register}
                                errors={errors}
                                id="acct"
                                name="acct"
                                type="text"
                                labelText={t('account')}
                                labelClass="control-label"
                                disabled={true}
                                value={detail.acct}
                            /> */}
                <Controller
                  name="acct"
                  control={control}
                  render={({ field, fieldState }) => (
                    <MaskedFormInput
                      {...field}
                      type="text"
                      labelClass="control-label"
                      labelText={t("account")}
                      maskType="account"
                      maskView={maskView}
                      setMaskView={() => {
                        setMaskView((prev) => {
                          return !prev;
                        });
                      }}
                      disabled={true}
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />
              </div>
              <div className="col-12 lg:col-6">
                {/* <FormInput
                                register={register}
                                errors={errors}
                                id="name"
                                name="name"
                                type="text"
                                labelText={t('user_name')}
                                labelClass={`${disabled === false ? 'required' : ''}`}
                                disabled={disabled}
                                rules={setValidForm('name')}
                            /> */}
                <Controller
                  name="name"
                  control={control}
                  rules={setValidForm("name")}
                  render={({ field, fieldState }) => (
                    <MaskedFormInput
                      {...field}
                      type="text"
                      labelClass={`${disabled === false ? "required" : ""}`}
                      labelText={t("user_name")}
                      maskType="name"
                      maskView={maskView || !disabled} //編輯階段固定明碼,不受眼睛影響
                      setMaskView={() => {
                        setMaskView((prev) => {
                          return !prev;
                        });
                      }}
                      disabled={disabled}
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />
              </div>
              {/* 暫時不要phone */}
              {/* <div className="col-12 lg:col-6">
                            <FormInput
                                register={register}
                                errors={errors}
                                id="phone"
                                name="phone"
                                type="tel"
                                labelText={t('tel')}
                                labelClass={`${disabled === false ? 'required' : ''}`}
                                rules={setValidForm('phone')}
                                disabled={disabled}
                            />
                        </div> */}
              <div className="col-12 lg:col-6">
                {/* <FormInput
                                register={register}
                                errors={errors}
                                id="email"
                                name="email"
                                type="text"
                                labelText={t('user_email')}
                                labelClass={`${disabled === false ? 'required' : ''}`}
                                disabled={disabled}
                                rules={setValidForm('email')}
                            /> */}
                <Controller
                  name="email"
                  control={control}
                  rules={setValidForm("email")}
                  render={({ field, fieldState }) => (
                    <MaskedFormInput
                      {...field}
                      type="email"
                      labelClass={`${disabled === false ? "required" : ""}`}
                      labelText={t("user_email")}
                      maskType="email"
                      maskView={maskView || !disabled} //編輯階段固定明碼,不受眼睛影響
                      setMaskView={() => {
                        setMaskView((prev) => {
                          return !prev;
                        });
                      }}
                      disabled={disabled}
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />
              </div>

              {action === "update" && (
                <>
                  <div className="col-12 lg:col-6">
                    <label htmlFor="role" className={`form-label ${disabled === false ? "required" : ""}`}>
                      {t("role")}
                    </label>
                    <Controller
                      name="roleSeq"
                      control={control}
                      rules={setValidForm("roleSeq")}
                      render={({ field, fieldState }) => (
                        <TreeSelect
                          filter
                          showClear
                          disabled={disabled}
                          appendTo={"self"}
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="roleSeq"
                          control={control}
                          options={roleList}
                          className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="col-12 lg:col-6">
                    <label htmlFor="status" className={`form-label ${disabled === false ? "required" : ""}`}>
                      {t("status")}
                    </label>
                    <Controller
                      name="status"
                      control={control}
                      rules={setValidForm("status")}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          disabled={disabled || field.value === "9"}
                          filter
                          appendTo={"self"}
                          optionLabel="label"
                          optionValue="value"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="status"
                          control={control}
                          options={statusList}
                          className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                </>
              )}

              {action === "detail" && (
                <>
                  <div className="col-12 lg:col-6">
                    <FormInput
                      register={register}
                      errors={errors}
                      id="roleName"
                      name="roleName"
                      type="text"
                      labelText={t("role")}
                      labelClass="control-label"
                      disabled={true}
                    />
                  </div>
                  <div className="col-12 lg:col-6">
                    <FormInput
                      register={register}
                      errors={errors}
                      id="status"
                      name="status"
                      type="text"
                      labelText={t("status")}
                      labelClass="control-label"
                      disabled={true}
                    />
                  </div>
                </>
              )}

              {/* Button替換區 */}
              <div className="col-12 gap-2 flex-all-center">
                {/* 編輯模式唯讀階段 出現編輯按鈕 */}
                {action === "update" && disabled && (
                  <Button type="button" label={t("button.edit")} size="small" onClick={handleStartEdit} />
                )}
                {/* 待審核出現 通過 退回 */}
                {getValues("status") === "9" && disabled === false && (
                  <>
                    <Button
                      onClick={() => {
                        handlePassOrReject("2", getValues("roleSeq"));
                      }}
                      type="button"
                      label={t("button.pass")}
                      size="small"
                    />
                    <Button
                      outlined
                      size="small"
                      type="button"
                      label={t("button.rejected")}
                      onClick={() => {
                        handlePassOrReject("3");
                      }}
                    />
                  </>
                )}
                {/* 啟用/停用 */}
                {getValues("status") !== "9" && disabled === false && (
                  <>
                    <Button disabled={!isValid} type="submit" label={t("button.confirm")} size="small" />
                    <Button
                      type="button"
                      outlined
                      size="small"
                      label={t("button.cancel")}
                      onClick={(e) => {
                        e.preventDefault();
                        handleCancelEdit();
                      }}
                    />
                  </>
                )}
                {/* 停用 出現刪除按鈕 (編輯模式僅編輯階段出現) */}
                {itemObj?.statusCode === "1" && (action !== "update" || !disabled) && (
                  <Button
                    onClick={() => {
                      setDelDialog(true);
                      setDelContent(t("confirm_delete_acct", { acct: getValues("name") }));
                    }}
                    severity="danger"
                    type="button"
                    label={t("button.delete")}
                    size="small"
                  />
                )}
              </div>
            </form>
          </div>
        </div>

        {/* 刪除 */}
        <PrimeConfirmDialog
          visible={delDialog}
          onClose={() => {
            setDelDialog(false);
          }}
          onConfirm={() => {
            confirmDel();
          }}
          title={t("button.delete")}
          bodyTemplate={delContent}
        />
      </>
    );
}

export default SubAccountDetail;

